import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import TooltipCommerceStore from 'components/TooltipCommerce';

import styles from './ItemVariantSalesTypesField.css';

class ItemVariantSalesTypesFields extends React.Component {
  render() {
    const {
      member,
      index,
      fields,
      isDisableForm,
      ecommerceAttributes,
    } = this.props;
    const isHide =
      fields.length === 1 &&
      (fields.get(index).name === undefined || fields.get(index).name === '')
        ? 'hide'
        : 'show';
    const isFirstColumn = index === 0;
    return (
      <div className="mk-grouped-input">
        {isHide !== 'hide' && (
          <div className={`form-group col-md-6`}>
            {ecommerceAttributes && isFirstColumn && (
              <div className={`panel-heading ${styles['panel-head']}`}>
                <label>Variant Name</label>
              </div>
            )}
            <Field
              name={`${member}.name`}
              component={SettingField}
              className="form-control"
              placeholder="Name"
              dis={fields.get(index).is_generated || isDisableForm}
              inputClassName={ecommerceAttributes && styles['input-ecommerce']}
            />
          </div>
        )}
        <div
          className={`item-variant-sales-type-input-sku form-group ${
            isHide === 'hide' ? 'col-md-12' : 'col-md-6'
          }`}
        >
          {ecommerceAttributes && isFirstColumn && (
            <div className={`panel-heading ${styles['panel-head']}`}>
              <TooltipCommerceStore placement="top" delay={200} name={'sku'}>
                <label>
                  SKU
                  <span
                    className={`glyphicon glyphicon-info-sign ${
                      styles['icon-container']
                    }`}
                  />
                </label>
              </TooltipCommerceStore>
            </div>
          )}
          <Field
            name={`${member}.sku`}
            component="input"
            className={`form-control text-align-last-left ${ecommerceAttributes &&
              styles['input-ecommerce']}`}
            placeholder="SKU"
            disabled={isDisableForm}
          />
        </div>
      </div>
    );
  }
}

ItemVariantSalesTypesFields.propTypes = {
  member: PropTypes.object,
  index: PropTypes.integer,
  fields: PropTypes.object,
};

export default ItemVariantSalesTypesFields;
